
export const CVTheme = {
	backgroundColor: "#FFFFFF",
	surfaceColor: "#D4E7DE",

	defaultHeading: { fontFamily: "Georgia", fontWeight: "bold", fontSize: "24pt" },
	headingSurname: { color: "#0C6B55", fontFamily: "Georgia", fontWeight: "bold", fontSize: "24pt" },
	headingEmploy: { fontFamily: "Georgia", fontSize: "16pt" },
	headingDetails: { fontFamily: "Georgia", fontSize: "11pt", lineHeight: 1.0, marginTop: 20, },
	headingSection: {
		color: "#0C6B55", fontFamily: "Georgia", fontWeight: "bold", fontSize: "12pt",
		marginRight: 10, flexGrow: 1, flexShrink: 0,
	},
	jobDates: { fontFamily: "Georgia", fontSize: "9pt", lineHeight: "1.2" },
	jobDetails: {
		color: "#406376", fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2"
	},
	jobDescription: { fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2" },

	sectionSeparator: "solid 1.5pt " + "#4A9A82",
	listSeparator: "#4A9A82",

	VBox: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" },
	HBox: { display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" },
	educationBold: { fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2", fontWeight: "bold" },
	education: { fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2" },
	skillHeader: { color: "#406376", fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2" },
	skillList: { fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2" },
	hobbiesHeader: { color: "#406376", fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2" },
	hobbies: { color: "black", fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2" },
	contact: { color: "black", fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2" },
	language: { color: "black", fontFamily: "Georgia", fontSize: "11pt", lineHeight: "1.2" },

	headerMargin: 50,

}